import type { I18nLocale } from '#/i18n/types/I18nLocale';

export const searchGroupsPathByLocale = {
  en: '/en/groups',
  es: '/es/grupos',
  pt: '/pt/grupos',
} satisfies Record<I18nLocale, string>;

export const searchGroupsPaths = Object.values(searchGroupsPathByLocale);

export const searchGroupsPathsWithoutLang = Array.from(
  new Set(searchGroupsPaths.map((path) => path.substring(3))),
);
